import { render, staticRenderFns } from "./SerializationTask.vue?vue&type=template&id=75d357b4&scoped=true"
import script from "./SerializationTask.vue?vue&type=script&lang=js"
export * from "./SerializationTask.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75d357b4",
  null
  
)

export default component.exports